import { CardWithC4CssProps } from './CssConfig';

export const liveJobPipelineConfigs = [
  {
    componentReference: 'title',
    label: 'Current job pipeline',
    id: 'live_job_pipeline-holder',
    cssProps: {
      width: '100%',
      display: 'block',
    },
    count: 6,
  },
  {
    componentReference: 'container',
    id: 'live_job_pipeline-cards-container',
    children: [
      // Prospect card hidden — uncomment to show as first tile
      // {
      //   containerType: 'live_job_pipeline',
      //   componentType: 'card',
      //   componentReference: 'card',
      //   id: 'live_job_pipeline_prospect',
      //   selected: false,
      //   cssProps: CardWithC4CssProps,
      //   ui: {
      //     renderType: 'card',
      //     header: 'prospect',
      //     id: 'prospect',
      //     value: 12,
      //     topLabel: 'Currently in prospect stages',
      //     bottomLabel: 'APPLICANTS',
      //     truncationLength: 18,
      //   },
      //   api: {
      //     subject_type: 'live_job_pipeline',
      //     metadata: {
      //       tileKey: 'live_job_pipeline_prospect',
      //       componentType: 'card',
      //       apiParam: 'card',
      //       headerKey: 'prospect',
      //       id: 'live_job_pipeline_prospect',
      //     },
      //   },
      // },
      {
        containerType: 'live_job_pipeline',
        componentType: 'card',
        componentReference: 'card',
        id: 'live_job_pipeline_application_review',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'application_review',
          id: 'application_review',
          value: 40,
          topLabel: 'Currently in application review stages',
          bottomLabel: 'APPLICANTS',
          truncationLength: 18,
        },
        api: {
          subject_type: 'live_job_pipeline',
          metadata: {
            tileKey: 'live_job_pipeline_application_review',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'application_review',
            id: 'live_job_pipeline_application_review',
          },
        },
      },
      {
        containerType: 'live_job_pipeline',
        componentType: 'card',
        componentReference: 'card',
        id: 'live_job_pipeline_interviewed',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'interviews',
          id: 'interviews',
          value: 35,
          topLabel: 'Currently in interview stages',
          bottomLabel: 'APPLICANTS',
          truncationLength: 18,
        },
        api: {
          subject_type: 'live_job_pipeline',
          metadata: {
            tileKey: 'live_job_pipeline_interviewed',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'interviews',
            id: 'live_job_pipeline_interviewed',
          },
        },
      },
      {
        containerType: 'live_job_pipeline',
        componentType: 'card',
        componentReference: 'card',
        id: 'live_job_pipeline_offer',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'offer',
          id: 'offer',
          value: 22,
          topLabel: 'Currently in offer stages',
          bottomLabel: 'APPLICANTS',
          truncationLength: 18,
        },
        api: {
          subject_type: 'live_job_pipeline',
          metadata: {
            tileKey: 'live_job_pipeline_offer',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'offer',
            id: 'live_job_pipeline_offer',
          },
        },
      },
      {
        containerType: 'live_job_pipeline',
        componentType: 'card',
        componentReference: 'card',
        id: 'live_job_pipeline_hired',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'hired',
          id: 'hired',
          value: 5,
          topLabel: 'Currently in hired stages',
          bottomLabel: 'APPLICANTS',
          truncationLength: 18,
        },
        api: {
          subject_type: 'live_job_pipeline',
          metadata: {
            tileKey: 'live_job_pipeline_hired',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'hired',
            id: 'live_job_pipeline_hired',
          },
        },
      },
    ],
  },
  {
    containerType: 'live_job_pipeline',
    componentType: 'chart',
    componentReference: 'chart',
    id: 'live_job_pipeline_chart',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Current job pipeline',
      id: 'live_job_pipeline_chart',
      chartData: {
        categories: [
          'Prospect',
          'Application review',
          'Interviews',
          'Offer',
          'Hired',
        ],
        series: [
          { name: 'Prospect', y: 220 },
          { name: 'Application Review', y: 1387 },
          { name: 'Interviews', y: 624 },
          { name: 'Offer', y: 222 },
          { name: 'Hired', y: 53 },
        ],
      },
      chartType: 'horizontalStackedBar',
      hideAxisValues: true,
      xTitle: 'Pipeline stage',
      yTitle: 'Number of candidates',
    },
    api: {
      subject_type: 'live_job_pipeline',
      metadata: {
        tileKey: 'live_job_pipeline_chart',
        componentType: 'chart',
        apiParam: 'chart_table',
        headerKeys: [
          'prospect_actual_count',
          'application_review_actual_count',
          'interviews_actual_count',
          'offer_actual_count',
          'hired_actual_count',
        ],
        id: 'live_job_pipeline_chart',
      },
    },
  },
  {
    containerType: 'live_job_pipeline',
    componentType: 'table',
    componentReference: 'table',
    id: 'live_job_pipeline_table',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Current job pipeline',
      id: 'live_job_pipeline_table',
      tableData: [
        {
          ds: '0',
          dt: null,
          header: 'Software Engineer',
          g1: 'Software Engineer',
          g2: null,
          time_in_prospect: 0,
          time_in_application_review: 0,
          time_in_interviews: 0,
          time_in_offer: 0,
          time_in_hired: 0,
          time_in_rejected: 0,
          prospect_total_count: 0,
          application_review_total_count: 0,
          interviews_total_count: 0,
          offer_total_count: 0,
          hired_total_count: 0,
          rejected_total_count: 0,
          prospect_actual_count: 0,
          application_review_actual_count: 0,
          interviews_actual_count: 0,
          offer_actual_count: 0,
          hired_actual_count: 0,
          rejected_actual_count: 0,
          prospect_total_count_total: 220,
          prospect_total_count_per: 0,
          application_review_total_count_total: 1421,
          application_review_total_count_per: 0,
          interviews_total_count_total: 651,
          interviews_total_count_total_per: 0,
          offer_total_count_total: 225,
          offer_total_count_per: 0,
          hired_total_count_total: 54,
          hired_total_count_per: 0,
          subRows: [],
        },
        {
          ds: '0',
          dt: null,
          header: 'Product Manager',
          g1: 'Product Manager',
          g2: null,
          time_in_prospect: 0,
          time_in_application_review: 0,
          time_in_interviews: 0,
          time_in_offer: 0,
          time_in_hired: 0,
          time_in_rejected: 0,
          prospect_total_count: 0,
          application_review_total_count: 0,
          interviews_total_count: 0,
          offer_total_count: 0,
          hired_total_count: 0,
          rejected_total_count: 0,
          prospect_actual_count: 0,
          application_review_actual_count: 0,
          interviews_actual_count: 0,
          offer_actual_count: 0,
          hired_actual_count: 0,
          rejected_actual_count: 0,
          prospect_total_count_total: 220,
          prospect_total_count_per: 0,
          application_review_total_count_total: 1421,
          application_review_total_count_per: 0,
          interviews_total_count_total: 651,
          interviews_total_count_total_per: 0,
          offer_total_count_total: 225,
          offer_total_count_per: 0,
          hired_total_count_total: 54,
          hired_total_count_per: 0,
          subRows: [],
        },
        {
          ds: '0',
          dt: null,
          header: 'Data Analyst',
          g1: 'Data Analyst',
          g2: null,
          time_in_prospect: 12005320,
          time_in_application_review: 25043538,
          time_in_interviews: 86845123,
          time_in_offer: 4654413,
          time_in_hired: 369004,
          time_in_rejected: 0,
          prospect_total_count: 18,
          application_review_total_count: 111,
          interviews_total_count: 75,
          offer_total_count: 29,
          hired_total_count: 7,
          rejected_total_count: 0,
          prospect_actual_count: 14,
          application_review_actual_count: 76,
          interviews_actual_count: 72,
          offer_actual_count: 25,
          hired_actual_count: 7,
          rejected_actual_count: 0,
          prospect_total_count_total: 220,
          prospect_total_count_per: '8.2',
          application_review_total_count_total: 1421,
          application_review_total_count_per: '7.8',
          interviews_total_count_total: 651,
          interviews_total_count_total_per: '11.5',
          offer_total_count_total: 225,
          offer_total_count_per: '12.9',
          hired_total_count_total: 54,
          hired_total_count_per: '13.0',
          subRows: [],
        },
        {
          ds: '0',
          dt: null,
          header: 'UX Designer',
          g1: 'UX Designer',
          g2: null,
          time_in_prospect: 56000000,
          time_in_application_review: 168857899,
          time_in_interviews: 86283705,
          time_in_offer: 17013588,
          time_in_hired: 1475988,
          time_in_rejected: 0,
          prospect_total_count: 142,
          application_review_total_count: 866,
          interviews_total_count: 408,
          offer_total_count: 138,
          hired_total_count: 31,
          rejected_total_count: 0,
          prospect_actual_count: 130,
          application_review_actual_count: 706,
          interviews_actual_count: 324,
          offer_actual_count: 117,
          hired_actual_count: 31,
          rejected_actual_count: 0,
          prospect_total_count_total: 220,
          prospect_total_count_per: '64.5',
          application_review_total_count_total: 1421,
          application_review_total_count_per: '60.9',
          interviews_total_count_total: 651,
          interviews_total_count_total_per: '62.7',
          offer_total_count_total: 225,
          offer_total_count_per: '61.3',
          hired_total_count_total: 54,
          hired_total_count_per: '57.4',
          subRows: [],
        },
        {
          ds: '0',
          dt: null,
          header: 'DevOps Engineer',
          g1: 'DevOps Engineer',
          g2: null,
          time_in_prospect: 9800000,
          time_in_application_review: 24750108,
          time_in_interviews: 6715105,
          time_in_offer: 4729548,
          time_in_hired: 851218,
          time_in_rejected: 0,
          prospect_total_count: 60,
          application_review_total_count: 444,
          interviews_total_count: 168,
          offer_total_count: 58,
          hired_total_count: 16,
          rejected_total_count: 0,
          prospect_actual_count: 54,
          application_review_actual_count: 368,
          interviews_actual_count: 134,
          offer_actual_count: 44,
          hired_actual_count: 16,
          rejected_actual_count: 0,
          prospect_total_count_total: 220,
          prospect_total_count_per: '27.3',
          application_review_total_count_total: 1421,
          application_review_total_count_per: '31.2',
          interviews_total_count_total: 651,
          interviews_total_count_total_per: '25.8',
          offer_total_count_total: 225,
          offer_total_count_per: '25.8',
          hired_total_count_total: 54,
          hired_total_count_per: '29.6',
          subRows: [],
        },
      ],
      metric: 'time_in_stage',
    },
    api: {
      subject_type: 'live_job_pipeline',
      metadata: {
        tileKey: 'live_job_pipeline_table',
        componentType: 'table',
        apiParam: 'chart_table',
        filters: {
          group_by_1: { id: 'job_name', label: 'Job name', key: 'job_name' },
          group_by_2: { id: null, label: 'None' },
          metrics: { id: 'time_in_stage', label: 'Time in stage' },
        },
        headerKeys: [
          'prospect_actual_count',
          'application_review_actual_count',
          'interviews_actual_count',
          'offer_actual_count',
          'hired_actual_count',
        ],
        id: 'live_job_pipeline_table',
      },
    },
  },
];
